<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/mess">A Message to the Fans from Larry Nance and Craig Ehlo</a></p>
<p class="toc"><a href="#/for1">Foreword, by Mary Schmitt Boyer</a></p>
<p class="toc"><a href="#/for2">Foreword, by Fred McLeod</a></p>
<p class="toc"><a href="#/for3">Foreword, by Austin Carr</a></p>
<p class="toc"><a href="#/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. The Beginning</a></p>
<p class="toc"><a href="#/chapter02">2. The Miracle</a></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Lost Years</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The Lenny Wilkens Era</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Czar</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. The Young Guns</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. The Strike</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. The Dark Years</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. The King Arrives</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. The Trade</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. The MVP</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. The Decision</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. The Lotto Winners</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. The Future Is Now</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. The King Comes Home</span></p>
<p class="toc1"><span href="#/epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/back" title="Link target outside of Sample">By the Numbers</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?51e0a6a4